module.exports = __webpack_public_path__ + "static/media/tree_24.9a5dd407.jpeg";